import { MapBoundaries } from "@/types/map.type";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type MapState = {
  /**
   * The last bounds that data was fetched for.
   * Used to prevent unnecessary refetching when user pans within this area.
   */
  lastBounds: MapBoundaries | null;
};

const initialState: MapState = {
  lastBounds: null
};

const mapSlice = createSlice({
  name: "map",
  initialState,
  reducers: {
    /**
     * Update the last bounds when user moves outside the previously fetched area.
     * This triggers data to be fetched for the new area.
     */
    setLastBounds: (state, action: PayloadAction<MapBoundaries>) => {
      state.lastBounds = action.payload;
    },
    /**
     * Clear the last bounds to force a refetch on the next viewport change.
     * Call this when filters change or when you need fresh data.
     */
    clearLastBounds: (state) => {
      state.lastBounds = null;
    }
  }
});

export const { setLastBounds, clearLastBounds } = mapSlice.actions;
export default mapSlice.reducer;

// Selectors
export const selectLastBounds = (state: { map: MapState }) =>
  state.map.lastBounds;
